import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PortalCouponListItem from './PortalCouponListItem';

export default class PortalCouponList extends Component {
  render () {
    const {
      device,
      coupons,
      handleReceiveCoupon,
      handleReloadReceivedCoupon,
      renderCount,
      emptyCouponMessage
    } = this.props;

    if (renderCount == 0 || coupons.size === 0) {
      return (
        <div className="list_coupon">
          <p className="desc_empty">{emptyCouponMessage}</p>
        </div>
      );
    }
    return (
      <div className="list_coupon">
        <ul>
          {coupons.map((coupon, idx) => {
            if (idx >= renderCount) {
              return null;
            }
            const type = coupon.get('receivedType');
            return (
              <PortalCouponListItem
                device={device}
                key={idx}
                index={idx}
                coupon={coupon}
                handleReceiveCoupon={handleReceiveCoupon}
                handleReloadReceivedCoupon={handleReloadReceivedCoupon}
                isExpired={type === 'expired'}
                isUsed={type === 'used'}
                isReceived={type === 'usable'}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

PortalCouponList.propTypes = {
  device: PropTypes.object.isRequired,
  coupons: PropTypes.object.isRequired,
  emptyCouponMessage: PropTypes.string,
  handleReceiveCoupon: PropTypes.func,
  handleReloadReceivedCoupon: PropTypes.func,
  renderCount: PropTypes.number
};

PortalCouponList.defaultProps = {
  emptyCouponMessage: '쿠폰이 없습니다.',
  renderCount: 100,
  logSection: 'etc'
};


// WEBPACK FOOTER //
// ./src/components/PortalCouponList/index.js